export default {
  inventoryTransfer: {
    search: {
      allotNo: '库存调拨单号',
      allotNoPlaceholder: '请输入库存调拨单号',
      allotStatus: '状态',
      allotStatusPlaceholder: '请选择状态',
      preAllotBatchNo: '调拨前批次号',
      proAllotBatchNo: '调拨后批次号',
      allotDate: '调拨日期',
      allotDateStart: '调拨日期开始日期',
      allotDateStartPlaceholder: '请选择调拨日期开始日期',
      allotDateEnd: '调拨日期结束日期',
      allotDateEndPlaceholder: '请选择调拨日期结束日期',
      allotOutStorage: '调出仓库',
      allotOutStoragePlaceholder: '请选择调出仓库',
      allotInStorage: '调入仓库',
      allotInStoragePlaceholder: '请选择调入仓库',
      salesmanNo: '业务员',
      salesmanNoPlaceholder: '请选择业务员',
      allotDepartmentName: '部门',
      allotDepartmentNamePlaceholder: '请选择部门',
      allotCompanyName: '公司',
      allotCompanyNamePlaceholder: '请选择公司',
      allotCreateDateStart: '制单日期起',
      allotCreateDateStartPlaceholder: '请选择制单日期起',
      allotCreateDateEnd: '制单日期至',
      allotCreateDateEndPlaceholder: '请选择制单日期至',
      allotCreatePerson: '制单人',
      allotCreatePersonPlaceholder: '请选择制单人',
      nameVoyageLicense: '船名/航次',
      nameVoyageLicensePlaceholder: '请输入船名/航次',
      freightInformation: '货运信息',
      freightInformationPlaceholder: '请输入货运信息',
      allotCreateDate: '制单日期',
      productName: '商品描述',
      productNamePlaceholder: '请输入商品描述',
      confirmAllotOutAmount: '确认调出数量',
    },
    form: {
      title: '库存调拨单',
      info: '基本信息',
      goodInfo: '商品调拨信息',
      transportInfo: '运输信息',
      outboundNo: '调拨单号',
      outboundNoPlaceholder: '系统自动生成',
      outboundCreatePerson: '制单人',
      outboundStatus: '库存调拨单状态',
      companyName: '公司',
      departmentName: '部门',
      outboundCreateDate: '制单日期',
      allotDate: '调拨日期',
      outboundPrintTime: '确认日期',
      outboundPrintTimePlaceholder: '生效确认后生成',
      deliveryMethod: '调拨方式',
      deliveryMethodPlaceholder: '请选择调拨方式',
      outboundCreateTime: '调拨日期',
      outboundCreateTimePlaceholder: '请选择调拨日期',
      validDateTo: '有效期至',
      validDateToPlaceholder: '请选择有效期至',
      contactPerson: '船名航次',
      contactPersonPlaceholder: '请输入船名航次',
      outboundStorageNo: '调出仓库',
      outboundStorageNoPlaceholder: '请选择',
      inboundStorageNo: '调入仓库',
      inboundStorageNoPlaceholder: '请选择',
      storageContactPhone: '仓库联系方式',
      storageContactPhonePlaceholder: '请输入仓库联系方式',
      outboundType: '调拨类型',
      outboundTypePlaceholder: '请选择调拨类型',
      customerNo: '客户名称',
      customerNoPlaceholder: '请选择客户',
      deliveryNote: '备注',
      deliveryNotePlaceholder: '请输入',
      storageIsDirectDeliver: '仓库类型',
      storageIsDirectDeliverPlaceholder: '请选择仓库类型',
      good: {
        businessInboundBatchNo: '当前批次号',
        businessInboundBatchNoPlaceholder: '请选择',
        outboundBatchNo: '调拨后批次号',
        contractNo: '合同编号',
        projectNo: '项目编号',
        settlendBatchNo: '结算批次号',
        distributionBatchNo: '物流批次号',
        productNo: '商品编号',
        productName: '商品描述',
        suppiler: '供应商',
        productUnit: '单位',
        businessOrder: '调出',
        businessOrderQuantity: '业务调出数量',
        businessOrderQuantityPlaceholder: '请输入业务调出数量',
        businessOrderPackage: '业务调出件数',
        businessOrderPackagePlaceholder: '请输入业务调出件数',
        ensureOutQuantity: '确认调出数量',
        ensureOutPackage: '确认调出件数',
        logisticsOutQuantity: '物流实出数量',
        logisticsOutPackage: '物流实出件数',
        storageShouldSend: '调入',
        storageShouldSendQuantity: '物流已入库数量',
        storageShouldSendPackage: '物流已入库件数',
        storageSendQuantity: '确认调入数量',
        storageSendPackage: '确认调入件数',
        storageSendQuantityPlaceholder: '请输入确认调入数量',
        storageSendPackagePlaceholder: '请输入确认调入件数',
        nameVoyageLicense: '单价',
        warehouseReceiptsNo: '金额',
        warehouseReceiptsNoPlaceholder: '请输入仓单号',
      },
      shippingMethod: '运输方式',
      shippingMethodPlaceholder: '请选择运输方式',
      transport: {
        nameVoyageLicense: '船名/航次/车牌',
        freightInformation: '货运信息',
        contactPerson: '联系人',
        contactPhoneNo: '联系方式',
        identityCardNumber: '身份证号',
      },
    },
    btnList: {
      add: '新增',
      del: '删除',
      save: '保存',
      effectConfirm: '生效确认',
      transportRequst: '运输申请',
    },
    msg: {
      goodNeedMsg: '至少填写一条商品信息',
      selectWareHouse: '请先选择调出仓库',
      canNotConfirm: '前序单据还未完成，不能进行生效确认操作',
      transTip: '该调拨单已生成物流运输单，请选择其他单号',
    },
  },
};
